import { Component, computed, input } from '@angular/core';
import { MATERIALS, materialColorHex } from '@sim/content/materials';
import type { MaterialId } from '@sim/content/materials';

/**
 * The one visual identity for a material app-wide: a circular badge, colored by the material and
 * labeled with its short code. Used everywhere a material shows up outside the Pixi canvas itself
 * (which draws the same color/short-label pairing directly onto packets and source-yield badges).
 */
@Component({
  selector: 'app-material-icon',
  template: `{{ shortLabel() }}`,
  host: {
    class: 'inline-flex shrink-0 items-center justify-center rounded-full font-bold text-slate-950',
    role: 'img',
    '[style.background-color]': 'color()',
    '[style.width.px]': 'size()',
    '[style.height.px]': 'size()',
    '[style.font-size.px]': 'fontSize()',
    '[attr.aria-label]': 'label()',
  },
})
export class MaterialIconComponent {
  readonly material = input.required<MaterialId>();
  readonly size = input(24);

  protected readonly color = computed(() => materialColorHex(this.material()));
  protected readonly shortLabel = computed(() => MATERIALS[this.material()].shortLabel);
  protected readonly label = computed(() => MATERIALS[this.material()].label);
  protected readonly fontSize = computed(() => Math.round(this.size() * 0.36));
}
